import { LitElement, html, Splide } from '@hh/global.js'

class HHMobileMenuSlider extends LitElement {
  static properties = {
    slider: { state: true },
  }

  connectedCallback() {
    super.connectedCallback()

    const slider = this.querySelector(
      '.mobile-menu-v2__slider [data-mobile-menu-slider]'
    )
    if (slider) {
      this.initSlider(slider)
    }
  }

  initSlider(slider) {
    this.slider = new Splide(slider, {
      type: 'slide',
      perPage: 2,
      useScroll: false,
      rewind: false,
      arrows: false,
      pagination: false,
      autoplay: false,
      padding: { left: 16, right: 50 },
      gap: 10,
      drag: 'free',
      snap: false,
      easing: 'ease',
    })

    this.slider.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-mobile-slider', HHMobileMenuSlider)
